/*
 * @Author: 1697482796@qq.com 1697482796@qq.com
 * @Date: 2023-02-02 12:03:51
 * @LastEditors: 1697482796@qq.com 1697482796@qq.com
 * @LastEditTime: 2023-02-20 23:09:49
 * @FilePath: \sdy_webpack1\src\store\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    langType: 'zh-Hans',
    langClass: {
      ch: {
        news: '新闻',
        doctor: '医生',
        department: '科室',
        searchNow: '立即搜索',
        palceChange: '请选择',
        pleaseEnCont: '请输入内容',
        newsCenter: '新闻中心',
        makeAppoint: '预约挂号',
        makeAppointDesc: '手机挂号 方便快捷',
        intHospital: '互联网医院',
        intHospitalDesc: '复诊患者 问诊开药',
        zonHospital: '院内分区',
        zonHospitalDesc: '清晰导览 真诚服务',
        navSystem: '来院导航',
        navSystemDesc: '精准指引 轻松就医',
        introduce: '介绍',
        deptIntr: '科室介绍',
        hospitalPos: "新疆维吾尔自治区人民医院，位于中国新疆乌鲁木齐市天池路91号",
        specialist: '专家',
        acadeLeader: '学术带头人',
        disciLeader: '学科带头人',
        clinExperts: '临床专家',
        tel: '电 话',
        fax: '传 真',
        email: '邮 箱',
        postCode: '邮 编',
        addess: '地 址',
        allRigReser: '版权所有',
        backTop: '回到顶部',
        officDY: '官方抖音',
        handHosptil: '掌上医院',
        details: '详情介绍',
        youHere: '您的位置',
        hospHome: '医院首页',
        personalPro: '个人简介',
        noPhotos: '暂无照片',
        depCenter: '科室中心',
        expertInt: '专家介绍',
        allDepartments: '所有科室',
        appoDepartment: '预约科室',
        deptExperts: '科室专家',
        profeTitle: '职称',
        post: '职务',
        specialty: '专长',
        expertList: '专家列表',
        mentor: '导师',
        specialColumn: '专栏',
        searchResult: '搜索结果',
        doctorTitle: '医生职称',
        mainResearch: '主要研究',
        visitTime: '出诊时间',
        deptzdzkName: '国家临床重点专科',
        deptnkksName: '内科科室',
        deptwkksName: '外科科室',
        deptyjksName: '医技科室',
      },
      en: {
        news: 'News',
        doctor: 'Doctor',
        department: 'Department',
        searchNow: 'Search now',
        palceChange: 'Please select',
        pleaseEnCont: 'Please enter the content',
        newsCenter: 'News center',
        makeAppoint: 'Appointment Register',
        makeAppointDesc: 'Registration via Mobile Phone',
        intHospital: 'Internet Hospital',
        intHospitalDesc: 'Follow up with patients to inquire and prescribe medication',
        zonHospital: 'Zoned Hospital',
        zonHospitalDesc: 'Clear Guide, Sincere Service',
        navSystem: 'Navigation System',
        navSystemDesc: 'Gives Accurate Guidance and Makes Medical Treatment Easy',
        introduce: 'INTRODUCTION',
        deptIntr: 'DEPARTMENT INTRODUCTION',
        hospitalPos: "People's Hospital of Xinjiang Uygur Autonomous Region, located at 91 Tianchi Road, Urumqi, Xinjiang, China",
        specialist: 'expert',
        acadeLeader: 'Academic Leader',
        disciLeader: 'Discipline Leader',
        clinExperts: 'Clinical experts',
        tel: 'Tel',
        fax: 'Fax',
        email: 'E-mail',
        postCode: 'Postal Code',
        addess: 'Add',
        allRigReser: 'All Right Reserved',
        backTop: 'Back to Top',
        officDY: 'Official Douyin',
        handHosptil: 'Handheld Hospital',
        details: 'Details',
        youHere: 'You Are Here',
        hospHome: 'Hospital Homepage',
        personalPro: 'Personal Profile',
        noPhotos: 'No Photos',
        depCenter: 'Department Center',
        expertInt: 'Specialist Introduction',
        allDepartments: 'All departments',
        AppoDepartment: 'Appointment Department',
        deptExperts: 'Department experts',
        profeTitle: 'Professional Title',
        post: 'Post',
        specialty: 'Specialty',
        expertList: 'Expert List',
        mentor: 'mentor',
        specialColumn: 'special column',
        searchResult: 'Search Result',
        doctorTitle: "Doctor's title",
        mainResearch: 'Main research',
        visitTime: 'Visit time',
        deptzdzkName: 'National Key Clinical Specialty',
        deptnkksName: 'Internal Medicine Department',
        deptwkksName: 'Surgical Department',
        deptyjksName: 'Medical Technology Department',
      },
      ru: {
        news: 'новости',
        doctor: 'врачи',
        department: 'отделения',
        searchNow: 'поиск сейчас',
        palceChange: '',
        pleaseEnCont: 'Введите содержимое',
        newsCenter: 'Центр новости',
        makeAppoint: 'Запись на прием',
        makeAppointDesc: 'Регистрация по мобильному телефону',
        intHospital: 'Интернет-больница',
        intHospitalDesc: 'Пациентам выписывают лекарства',
        zonHospital: 'Zoned Hospital',
        zonHospitalDesc: 'четкое экскурсионное наведение, искреннее обслуживание',
        navSystem: 'Навигация в больницу',
        navSystemDesc: 'точное руководство, легкое обращение к врачебному приему',
        hospitalPos: "Народная больница Синьцзян-Уйгурского автономного района, расположенная по адресу: КНР, Синьцзян, город Урумчи, улица Тяньчи, №91",
        specialist: 'Специалисты',
        acadeLeader: 'Ученый ведущий',
        disciLeader: 'Ведущий научной отрасли',
        clinExperts: 'Клинический специалист',
        tel: 'Телефон',
        fax: 'факс',
        email: 'почтовый ящик',
        postCode: 'почтовый индекс',
        addess: 'адрес',
        allRigReser: 'все права защищены',
        backTop: 'Вверх.',
        officDY: 'фициальный аккаунт ТикТок',
        handHosptil: 'портативная больница',
        details: 'Подробности',
        youHere: 'ваше местонахождение',
        hospHome: 'Главная страница больницы',
        personalPro: 'личное профиль',
        noPhotos: 'фотография пока отсутствует',
        depCenter: 'центр отделений',
        expertInt: 'Представление экспертов',
        allDepartments: 'Все секции',
        AppoDepartment: 'Секция бронирования',
        deptExperts: 'Специалисты отдела',
        profeTitle: 'Служебное звание',
        post: 'должность',
        specialty: 'компетенция',
        expertList: 'Список экспертов',
        mentor: 'Учитель',
        specialColumn: 'Колонка',
        searchResult: 'Результаты поиска',
        doctorTitle: 'Название врача',
        mainResearch: 'Основные исследования',
        visitTime: 'Время посещения',
        deptzdzkName: 'Национальная клиническая специализация',
        deptnkksName: 'Терапевтическое отделение',
        deptwkksName: 'Хирургическое отделение',
        deptyjksName: 'Медицинско-техническое отделение',
      }
    },
    allMenuList: []
  },
  mutations: {
    updataLangType(state, value) {
      sessionStorage.setItem("langType", value);
      state.langType = value;
    },
    updataAllMenuList(state, value) {
      console.log('=======222', value)
      state.allMenuList = value;
    }
  }
})
  
//   mutations: {
//     updataLangType(state, info) {
//       console.log('这个值是', info)
//       sessionStorage.setItem("langType", info);
//       state.langType = info;
//     },
//   },
//   actions: {},
// });

// export default store;
